import React from "react";
import { Link } from "react-router-dom";
import "./Produits.css";

const products = [
  {
    id: 1,
    name: "Matériels de lutte contre l'incendie",
    image: "/assets/images/banner1.jpg",
    link: "/incendie",
    badge: "Sécurité",
    badgeClass: "securite",
    icon: "🔥",
  },
  {
    id: 2,
    name: "Équipements pétroliers",
    image: "/assets/images/banner2.jpg",
    link: "/petroliers",
    badge: "Industrie",
    badgeClass: "industrie",
    icon: "⛽",
  },
  {
    id: 3,
    name: "Robinetterie et instrumentation",
    image: "/assets/images/banner3.jpg",
    link: "/robinetterie",
    badge: "Technique",
    badgeClass: "technique",
    icon: "🔧",
  },
  {
    id: 4,
    name: "Équipements de salle de lavage",
    image: "/assets/images/banner4.jpg",
    link: "/lavage",
    badge: "Hygiène",
    badgeClass: "hygiene",
    icon: "💧",
  },
  {
    id: 5,
    name: "Équipements hydrauliques",
    image: "/assets/images/banner5.jpg",
    link: "/hydraulique",
    badge: "Mécanique",
    badgeClass: "mecanique",
    icon: "⚙️",
  },
  {
    id: 6,
    name: "Tuyauterie et accessoires de raccordement",
    image: "/assets/images/banner6.jpg",
    link: "/tuyauterie",
    badge: "Plomberie",
    badgeClass: "plomberie",
    icon: "🏗️",
  },
];

function Produits() {
  return (
    <div>
      {/* ═══════ Hero ═══════ */}
      <section className="produits-hero">
        <div className="produits-hero__container">
          <span className="produits-hero__label">Catalogue</span>
          <h1 className="produits-hero__title">
            Nos <span>Produits</span>
          </h1>
          <p className="produits-hero__desc">
            Explorez notre large gamme d'équipements conçus pour répondre aux
            besoins de sécurité, d'industrie pétrolière et bien plus encore.
          </p>
          <div className="produits-hero__breadcrumb">
            <Link to="/">Accueil</Link>
            <span>/</span>
            <span>Produits</span>
          </div>
        </div>
      </section>

      {/* ═══════ Products Grid ═══════ */}
      <section className="produits-section">
        <div className="produits-section__container">
          <div className="produits-grid">
            {products.map((product) => (
              <Link
                to={product.link}
                className="product-card"
                key={product.id}
              >
                <div className="product-card__image">
                  <img src={product.image} alt={product.name} />
                  <span
                    className={`product-card__badge product-card__badge--${product.badgeClass}`}
                  >
                    {product.badge}
                  </span>
                </div>

                <div className="product-card__body">
                  <h3 className="product-card__title">{product.name}</h3>

                  <div className="product-card__footer">
                    <span className="product-card__link">
                      Voir les produits →
                    </span>
                    <span className="product-card__icon">{product.icon}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Produits;
